import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { cn } from "@/design-system/lib/utils";

/**
 * Comm Log Standard §9.6 — top-nav entry for the central communication
 * log. Distinct from Internal Messaging's <c>MessageSquare</c> — a user
 * with both icons in their navbar must not confuse one for the other.
 *
 * NO unread-count badge. Communications are not "unread"; this is a
 * logbook, not an inbox.
 */
export function CommunicationsNavIcon({ className }: { className?: string }) {
  return (
    <Link
      to="/communications"
      aria-label="Communications log"
      title="Communications log"
      className={cn(
        "relative inline-flex items-center justify-center h-10 w-10 rounded-md",
        "text-white-pure/80 hover:text-white-pure hover:bg-white-pure/5",
        "focus-visible:outline-none focus-visible:shadow-goldRing",
        className,
      )}
    >
      <MessageCircle size={18} strokeWidth={1.5} aria-hidden />
    </Link>
  );
}
